export const calendarTheme = {
  surface: "bg-background",
  card: "bg-card backdrop-blur-xs",
  border: "border-border",
  shadow: "shadow-card",
  radius: "rounded-3xl",
  accent: "bg-accent",
  accentText: "text-accent-foreground",
  gold: "bg-[#b08a52]",
  ink: "text-foreground",
  muted: "text-muted-foreground",
};

